import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
// import './registerServiceWorker'
import '@/assets/styles/reset.scss'
import common from '@/assets/js/common.js'
import { Notify, Dialog } from 'vant'
import vueTouch from "vue-plugin-touch"
import touch from 'vue-directive-touch'
import VueI18n from 'vue-i18n'
import 'lib-flexible'
import 'vant/lib/index.css';
Vue.use(Notify).use(Dialog).use(vueTouch).use(touch).use(VueI18n);
Vue.prototype.common=common;

const i18n = new VueI18n({
    locale: localStorage.getItem("lang") || "uz_uz",
    messages: {
      'zh_cn': require('./assets/languages/zh_CN.json'),
	  'en_us': require('./assets/languages/en_US.json'),
	  'ky_kg': require('./assets/languages/ky_KG.json'),
	  'kk_kz': require('./assets/languages/kk_KZ.json'),
	  'ru_ru': require('./assets/languages/ru_RU.json'),
	  'tr_tr': require('./assets/languages/tr_TR.json'),
	  'ka_ge': require('./assets/languages/ka_GE.json'),
	  'ar_jo': require('./assets/languages/ar_JO.json'),
	  'id_id': require('./assets/languages/id_ID.json'),
	  'az_az': require('./assets/languages/az_AZ.json'),
	  'uz_uz': require('./assets/languages/uz_UZ.json')
    }
});

if (localStorage.getItem("lang") == 'ar_jo') {
    document.documentElement.setAttribute('dir', 'rtl');
} else {
    document.documentElement.setAttribute('dir', 'ltr');
}

Vue.config.productionTip = false;

window.vm = new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app');
